import React, { useState, useRef, useEffect } from "react";
import { Form, Button } from "react-bootstrap";
import Select from "react-select";
import Container from "react-bootstrap/Container";

import { Row } from "react-bootstrap";
import { Col } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import AuthService from "../../services/auth.service";
import AuthServiceV2 from "../../services/auth.serviceV2";
import { Modal } from "react-bootstrap";
import thailanddata from "../../file/raw_database.json";
import Static_modal from "../user/etc/Static_modal";
function EditProfileUser() {
  const handleClose = () => {
    setcheckuserdata(false);
    setmodalsuccess(false);
  };
  let Navigate = useNavigate();
  const { state } = useLocation();
  function regis() {
    Navigate("/profileuser");
  }
  const [data, setData] = useState("");
  const [Same, setSame] = useState(false);
  const [isCorporation, setIscorporation] = useState(undefined);
  const [dataCorporation, setDatacorporation] = useState({
    email: "",
    legalentity_number: "",
    branch_code: "",
    company_name: "",
    cur_address: "",
    cur_dis: "",
    cur_poscode: "",
    cur_province: "",
    cur_sub_dis: "",
  });
  const [modalToggle, setModalToggle] = useState({
    modalSuccess: false,
    modalDenied: false,
    modalErr: false,
    modalwait: false,
  });
  const [textBody, setTextBody] = useState();
  const date = new Date();
  function getPosition(string, subString, index) {
    console.log(string.split(subString, index).join(subString).length);
    return string.split(subString, index).join(subString).length;
  }
  useEffect(() => {
    //console.log(state.href.substring(getPosition(state.href,'/',3)))
    console.log(state);
    const checktype = sessionStorage.getItem("type_user");
    if (checktype === "corporation") {
      const checkcorpertation = AuthServiceV2.corporationdata();
      if (checkcorpertation != null) {
        checkcorpertation
          .then(function (result) {
            setIscorporation(true);
            setPhone(result.data.data.phone);
            setCurAddress(result.data.data.cur_address);
            setDatacorporation({
              email: result.data.data.email,
              legalentity_number: result.data.data.legalentity_number,
              branch_code: result.data.data.branch_code,
              company_name: result.data.data.company_name,
              cur_dis: result.data.data.cur_dis,
              cur_poscode: result.data.data.cur_poscode,
              cur_province: result.data.data.cur_province,
              cur_sub_dis: result.data.data.cur_sub_dis,
            });
            console.log(result);
          })
          .catch((error) => {
            setTextBody(error);
            setModalToggle({ ...modalToggle, modalErr: true });
          });
      }
    } else {
      const check = AuthServiceV2.getCurrentUser();
      if (check != null)
        check
          .then(function (result) {
            console.log(result);
            if (result) {
              console.log("passPIS");

              const data1 = AuthServiceV2.getCurrentUser()
                .then(function (result) {
                  setData(result.data.data);
                  //console.log(result.data.userdata);
                })
                .catch((error) => {
                  setTextBody(error);
                  setModalToggle({ ...modalToggle, modalErr: true });
                });
              const datecurrent = data.date_of_birth?.substring(0, 4);
              setTitle(data.title);
              setFirstname(data.f_name);
              setLastname(data.l_name);
              setPhone(data.phone);
              setOccupation(data.occupation);
              setDate_of_birth(data.date_of_birth);
              //console.log(data.date_of_birth.substring(0, 4))
              setAge(date.getFullYear() - datecurrent);
              setAddress(data.address);
              setrace(data.race);
              setnationality(data.nationality);
              setNat2(data.nationality);
              setProvince(data.province);
              setsub_dis(data.sub_dis);
              setDis(data.dis);
              setpos_code(data.pos_code);
              setCurAddress(data.cur_address);
              setCurProvince(data.cur_province);
              setCurSubdis(data.cur_sub_dis);
              setCurDis(data.cur_dis);
              setCurPoscode(data.cur_poscode);
            } else {
              //console.log("GDSNS");
              setcheckuserdata(true);
              const data1 = AuthServiceV2.getCurrentUser()
                .then(function (result) {
                  console.log(result);
                  setData(result.data.data);
                  setFirstname(data.f_name);
                  setLastname(data.l_name);
                  setPhone(result.data.data.phone);
                  //console.log(result.data.userdata);
                  setTimeout(() => {
                    setcheckuserdata(false);
                  }, 1500);
                })
                .catch((error) => {
                  setTextBody(error);
                  setModalToggle({ ...modalToggle, modalErr: true });
                });
            }
          })
          .catch((error) => {
            setTextBody(error);
            setModalToggle({ ...modalToggle, modalErr: true });
          });
    }
  }, [data.f_name]);
  const form = useRef();
  const checkBtn = useRef();
  const [checkuserdata, setcheckuserdata] = useState(false);
  const [modalsuccess, setmodalsuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [validated, setValidated] = useState(false);
  const [title, setTitle] = useState("");
  const [idnum, setIdnum] = useState("");
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [phone, setPhone] = useState("");
  const [occupation, setOccupation] = useState("");
  const [date_of_birth, setDate_of_birth] = useState("");
  const [age, setAge] = useState(0);
  const [race, setrace] = useState("");
  const [nationality, setnationality] = useState("");
  const [nat2, setNat2] = useState("");
  const [address, setAddress] = useState("");
  const [dis, setDis] = useState("");
  const [sub_dis, setsub_dis] = useState("");
  const [province, setProvince] = useState("");
  const [pos_code, setpos_code] = useState("");
  const [cur_address, setCurAddress] = useState("");
  const [cur_dis, setCurDis] = useState("");
  const [cur_sub_dis, setCurSubdis] = useState("");
  const [cur_province, setCurProvince] = useState("");
  const [cur_poscode, setCurPoscode] = useState("");
  const [backprevent, setBackprevent] = useState("");
  const [searchTerm1, setSearchTerm1] = useState([]);
  const [searchTerm2, setSearchTerm2] = useState([]);
  const [searchTerm3, setSearchTerm3] = useState([]);
  const [searchTerm4, setSearchTerm4] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [filterss, setFilterss] = useState(thailanddata);
  const [showdatasearch, setShowdatasearch] = useState([]);
  const [selectedOption1, setSelectedOption1] = useState("");
  const [selectedOption2, setSelectedOption2] = useState("");

  let amphoessm = "";
  let districts = "";
  let provinces = "";
  let poscodes = "";
  let curamphoessm = "";
  let curdistricts = "";
  let curprovinces = "";
  let curposcodes = "";
  let counts = 0;
  let counts2 = 0;
  const positions = [];
  const handleChangeprovince = (event) => {
    const setdata = event.target.value;
    let index = setdata.indexOf(",");
    while (index !== -1) {
      positions.push(index);
      index = setdata.indexOf(",", index + 1);
    }
    console.log(setdata);
    for (let i = 0; i < setdata.length; i++) {
      switch (true) {
        case i:
          console.log("sdsdsd");
          break;
        case i != positions[counts] && counts == 0:
          provinces += setdata[i];
          break;
        case i != positions[counts] && counts == 1:
          amphoessm += setdata[i];
          break;
        case i != positions[counts] && counts == 2:
          districts += setdata[i];
          break;
        case i == positions[counts]:
          counts++;
          break;
        default:
          poscodes += setdata[i];
      }
      // if (i) {
      //   console.log("sdsdsd")
      // } else if (i != positions[counts] && counts == 0) {
      //   districts += setdata[i];
      // } else if (i != positions[counts] && counts == 1) {
      //   amphoessm += setdata[i];
      // } else if (i != positions[counts] && counts == 2) {
      //   provinces += setdata[i];
      // } else if (i == positions[counts]) {
      //   counts++;
      // } else {
      //   poscodes += setdata[i];
      // }
    }
    setDis(amphoessm);
    setsub_dis(districts);
    setProvince(provinces);
    setpos_code(poscodes);
    setSearchTerm1(event.target.value);

    const filteredOptions = filterss.filter((option) =>
      option.province.includes(searchTerm1)
    );
    console.log(filteredOptions);
    setShowdatasearch(filteredOptions);
  };
  const handleClose_Modal = (close) => {
    setModalToggle({
      ...modalToggle,
      modalSuccess: close,
      modalDenied: close,
      modalErr: close,
      modalwait: close,
    });
    setTextBody("");
  };
  const handleChangeamphoe = (event) => {
    const setdata = event.target.value;
    let index = setdata.indexOf(",");
    while (index !== -1) {
      positions.push(index);
      index = setdata.indexOf(",", index + 1);
    }
    console.log(setdata);
    for (let i = 0; i < setdata.length; i++) {
      switch (true) {
        case i:
          console.log("sdsdsd");
          break;
        case i != positions[counts] && counts == 0:
          amphoessm += setdata[i];
          break;
        case i != positions[counts] && counts == 1:
          districts += setdata[i];
          break;
        case i != positions[counts] && counts == 2:
          provinces += setdata[i];
          break;
        case i == positions[counts]:
          counts++;
          break;
        default:
          poscodes += setdata[i];
      }
      // if (i) {
      //   console.log("sdsdsd")
      // } else if (i != positions[counts] && counts == 0) {
      //   districts += setdata[i];
      // } else if (i != positions[counts] && counts == 1) {
      //   amphoessm += setdata[i];
      // } else if (i != positions[counts] && counts == 2) {
      //   provinces += setdata[i];
      // } else if (i == positions[counts]) {
      //   counts++;
      // } else {
      //   poscodes += setdata[i];
      // }
    }
    setDis(amphoessm);
    setsub_dis(districts);
    setProvince(provinces);
    setpos_code(poscodes);
    setSearchTerm3(event.target.value);

    const filteredOptions = filterss.filter((option) =>
      option.amphoe.includes(searchTerm3)
    );
    console.log(filteredOptions);
    setShowdatasearch(filteredOptions);
  };
  const handleChangedistricts = (event) => {
    const setdata = event.target.value;
    let index = setdata.indexOf(",");
    while (index !== -1) {
      positions.push(index);
      index = setdata.indexOf(",", index + 1);
    }
    console.log(setdata);
    for (let i = 0; i < setdata.length; i++) {
      switch (true) {
        case i:
          console.log("sdsdsd");
          break;
        case i != positions[counts] && counts == 0:
          districts += setdata[i];
          break;
        case i != positions[counts] && counts == 1:
          amphoessm += setdata[i];
          break;
        case i != positions[counts] && counts == 2:
          provinces += setdata[i];
          break;
        case i == positions[counts]:
          counts++;
          break;
        default:
          poscodes += setdata[i];
      }
      // if (i) {
      //   console.log("sdsdsd")
      // } else if (i != positions[counts] && counts == 0) {
      //   districts += setdata[i];
      // } else if (i != positions[counts] && counts == 1) {
      //   amphoessm += setdata[i];
      // } else if (i != positions[counts] && counts == 2) {
      //   provinces += setdata[i];
      // } else if (i == positions[counts]) {
      //   counts++;
      // } else {
      //   poscodes += setdata[i];
      // }
    }
    setDis(amphoessm);
    setsub_dis(districts);
    setProvince(provinces);
    setpos_code(poscodes);
    setSearchTerm2(event.target.value);

    const filteredOptions = filterss.filter((option) =>
      option.district.includes(searchTerm2)
    );
    console.log(filteredOptions);
    setShowdatasearch(filteredOptions);
  };
  const handleChangeposcode = (event) => {
    const setdata = event.target.value;
    let index = setdata.indexOf(",");
    while (index !== -1) {
      positions.push(index);
      index = setdata.indexOf(",", index + 1);
    }
    console.log(setdata);
    for (let i = 0; i < setdata.length; i++) {
      switch (true) {
        case i:
          console.log("sdsdsd");
          break;
        case i != positions[counts] && counts == 0:
          poscodes += setdata[i];
          break;
        case i != positions[counts] && counts == 1:
          districts += setdata[i];
          break;
        case i != positions[counts] && counts == 2:
          amphoessm += setdata[i];
          break;
        case i == positions[counts]:
          counts++;
          break;
        default:
          provinces += setdata[i];
      }
      // if (i) {
      //   console.log("sdsdsd")
      // } else if (i != positions[counts] && counts == 0) {
      //   districts += setdata[i];
      // } else if (i != positions[counts] && counts == 1) {
      //   amphoessm += setdata[i];
      // } else if (i != positions[counts] && counts == 2) {
      //   provinces += setdata[i];
      // } else if (i == positions[counts]) {
      //   counts++;
      // } else {
      //   poscodes += setdata[i];
      // }
    }
    setDis(amphoessm);
    setsub_dis(districts);
    setProvince(provinces);
    setpos_code(poscodes);
    setSearchTerm4(Number(event.target.value));
    const filteredOptions = filterss.filter(
      (option) => option.zipcode === Number(event.target.value)
    );
    console.log(filteredOptions);
    setShowdatasearch(filteredOptions);
  };
  const handleChangecurprovince = (event) => {
    const setdata = event.target.value;
    let index = setdata.indexOf(",");
    while (index !== -1) {
      positions.push(index);
      index = setdata.indexOf(",", index + 1);
    }
    console.log(setdata);
    for (let i = 0; i < setdata.length; i++) {
      switch (true) {
        case i:
          console.log("sdsdsd");
          break;
        case i != positions[counts] && counts == 0:
          curprovinces += setdata[i];
          break;
        case i != positions[counts] && counts == 1:
          curamphoessm += setdata[i];
          break;
        case i != positions[counts] && counts == 2:
          curdistricts += setdata[i];
          break;
        case i == positions[counts]:
          counts++;
          break;
        default:
          curposcodes += setdata[i];
      }
    }
    setCurDis(curamphoessm);
    setCurSubdis(curdistricts);
    setCurProvince(curprovinces);
    setCurPoscode(curposcodes);
    setSearchTerm1(event.target.value);
    const check = sessionStorage.getItem("type_user");
    if (check === "corporation") {
      setDatacorporation({
        cur_dis: curamphoessm,
        cur_poscode: curposcodes,
        cur_province: curprovinces,
        cur_sub_dis: curdistricts,
      });
    }
    console.log(searchTerm1);
    const filteredOptions = filterss.filter((option) =>
      option.province.includes(searchTerm1)
    );
    console.log(filteredOptions);
    setShowdatasearch(filteredOptions);
  };
  const handleChangecuramphoe = (event) => {
    const setdata = event.target.value;
    let index = setdata.indexOf(",");
    while (index !== -1) {
      positions.push(index);
      index = setdata.indexOf(",", index + 1);
    }
    console.log(setdata);
    for (let i = 0; i < setdata.length; i++) {
      switch (true) {
        case i:
          console.log("sdsdsd");
          break;
        case i != positions[counts] && counts == 0:
          curamphoessm += setdata[i];
          break;
        case i != positions[counts] && counts == 1:
          curdistricts += setdata[i];
          break;
        case i != positions[counts] && counts == 2:
          curprovinces += setdata[i];
          break;
        case i == positions[counts]:
          counts++;
          break;
        default:
          curposcodes += setdata[i];
      }
    }
    setCurDis(curamphoessm);
    setCurSubdis(curdistricts);
    setCurProvince(curprovinces);
    setCurPoscode(curposcodes);
    setSearchTerm3(event.target.value);
    const check = sessionStorage.getItem("type_user");
    if (check === "corporation") {
      setDatacorporation({
        cur_dis: curamphoessm,
        cur_poscode: curposcodes,
        cur_province: curprovinces,
        cur_sub_dis: curdistricts,
      });
    }
    const filteredOptions = filterss.filter((option) =>
      option.amphoe.includes(searchTerm3)
    );
    console.log(filteredOptions);
    setShowdatasearch(filteredOptions);
  };
  const handleChangecurdistricts = (event) => {
    const setdata = event.target.value;
    let index = setdata.indexOf(",");
    while (index !== -1) {
      positions.push(index);
      index = setdata.indexOf(",", index + 1);
    }
    console.log(setdata);
    for (let i = 0; i < setdata.length; i++) {
      switch (true) {
        case i:
          console.log("sdsdsd");
          break;
        case i != positions[counts] && counts == 0:
          curdistricts += setdata[i];
          break;
        case i != positions[counts] && counts == 1:
          curamphoessm += setdata[i];
          break;
        case i != positions[counts] && counts == 2:
          curprovinces += setdata[i];
          break;
        case i == positions[counts]:
          counts++;
          break;
        default:
          curposcodes += setdata[i];
      }
    }
    setCurDis(curamphoessm);
    setCurSubdis(curdistricts);
    setCurProvince(curprovinces);
    setCurPoscode(curposcodes);
    setSearchTerm2(event.target.value);
    const check = sessionStorage.getItem("type_user");
    if (check === "corporation") {
      setDatacorporation({
        cur_dis: curamphoessm,
        cur_poscode: curposcodes,
        cur_province: curprovinces,
        cur_sub_dis: curdistricts,
      });
    }
    const filteredOptions = filterss.filter((option) =>
      option.district.includes(searchTerm2)
    );
    console.log(filteredOptions);
    setShowdatasearch(filteredOptions);
  };
  const handleChangecurposcode = (event) => {
    const setdata = event.target.value;
    let index = setdata.indexOf(",");
    while (index !== -1) {
      positions.push(index);
      index = setdata.indexOf(",", index + 1);
    }
    console.log(setdata);
    for (let i = 0; i < setdata.length; i++) {
      switch (true) {
        case i:
          console.log("sdsdsd");
          break;
        case i != positions[counts] && counts == 0:
          curposcodes += setdata[i];
          break;
        case i != positions[counts] && counts == 1:
          curdistricts += setdata[i];
          break;
        case i != positions[counts] && counts == 2:
          curamphoessm += setdata[i];
          break;
        case i == positions[counts]:
          counts++;
          break;
        default:
          curprovinces += setdata[i];
      }
    }
    setCurDis(curamphoessm);
    setCurSubdis(curdistricts);
    setCurProvince(curprovinces);
    setCurPoscode(curposcodes);
    setSearchTerm4(Number(event.target.value));
    const check = sessionStorage.getItem("type_user");
    if (check === "corporation") {
      setDatacorporation({
        cur_dis: curamphoessm,
        cur_poscode: curposcodes,
        cur_province: curprovinces,
        cur_sub_dis: curdistricts,
      });
    }
    const filteredOptions = filterss.filter(
      (option) => option.zipcode === Number(event.target.value)
    );
    console.log(filteredOptions);
    setShowdatasearch(filteredOptions);
  };

  const titles = [
    { value: "นาย", label: "นาย" },
    { value: "นาง", label: "นาง" },
    { value: "นางสาว", label: "นางสาว" },
  ];
  const [titl, settitl] = useState([
    { value: "นาย", label: "นาย" },
    { value: "นาง", label: "นาง" },
    { value: "นางสาว", label: "นางสาว" },
  ]);
  function handleChange(data) {
    console.log(data.target.value);
    setTitle(data.target.value);
  }
  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true);
  };
  const myStyle2 = {
    padding: "30px",
    textAlign: "center",
    color: "#0077B6",
    fontWeight: "700px",
    fontSize: "47px",
  };

  const handleLogin = (e) => {
    e.preventDefault();

    setLoading(true);
    console.log(
      title,
      firstname,
      lastname,
      date_of_birth,
      age,
      race,
      nationality,
      address,
      dis,
      sub_dis,
      province,
      pos_code,
      address,
      dis,
      sub_dis,
      province,
      pos_code,
      occupation
    );
    if (isCorporation !== undefined) {
      console.log("sdsdsdsd");
      AuthServiceV2.updatecorpdata(phone, cur_address, dataCorporation)
        .then((res) => {
          setmodalsuccess(true);
          setTimeout(() => {
            setmodalsuccess(false);
          }, 1500);
          console.log(res);
          Navigate(state.href.substring(getPosition(state.href, "/", 3)));

          Navigate(-1);
          window.location.reload();
        })
        .catch((error) => {
          setTextBody(error);
          setModalToggle({ ...modalToggle, modalErr: true });

          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();

          setLoading(false);
        });
    } else {
      if (Same === true) {
        AuthServiceV2.edituserdata(
          title,
          firstname,
          lastname,
          date_of_birth,
          age,
          race,
          nationality,
          address,
          dis,
          sub_dis,
          province,
          pos_code,
          address,
          dis,
          sub_dis,
          province,
          pos_code,
          occupation
        )
          .then((response) => {
            setmodalsuccess(true);
            setTimeout(() => {
              setmodalsuccess(false);
            }, 1500);
            console.log(response);
            if (
              state.href.substring(getPosition(state.href, "/", 3)) ===
              "/user/drone/datadrone"
            ) {
              Navigate("/user/drone/statusdrone");
              window.location.reload();
            } else {
              Navigate(state.href.substring(getPosition(state.href, "/", 3)));

              Navigate(-1);
              window.location.reload();
            }
            //AuthService.getCurrentUser(response.userid,response.jwt,login)
          })
          .catch((error) => {
            setTextBody(error);
            setModalToggle({ ...modalToggle, modalErr: true });

            const resMessage =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              error.toString();

            setLoading(false);
          });
      } else {
        AuthServiceV2.edituserdata(
          title,
          firstname,
          lastname,
          date_of_birth,
          age,
          race,
          nationality,
          address,
          dis,
          sub_dis,
          province,
          pos_code,
          cur_address,
          cur_dis,
          cur_sub_dis,
          cur_province,
          cur_poscode,
          occupation
        )
          .then((response) => {
            setmodalsuccess(true);
            setTimeout(() => {
              setmodalsuccess(false);
            }, 1500);
            console.log(response);
            if (
              state.href.substring(getPosition(state.href, "/", 3)) ===
              "/user/drone/datadrone"
            ) {
              Navigate("/user/drone/statusdrone");
              window.location.reload();
            } else {
              Navigate(state.href.substring(getPosition(state.href, "/", 3)));

              Navigate(-1);
              window.location.reload();
            }

            //AuthService.getCurrentUser(response.userid,response.jwt,login)
          })
          .catch((error) => {
            setTextBody(error);
            setModalToggle({ ...modalToggle, modalErr: true });

            const resMessage =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              error.toString();

            setLoading(false);
          });
      }

      setLoading(false);
    }

    //form.current.validateAll();
  };
  return (
    <div style={{ fontFamily: "Kanit" }}>
      <div className="container-main">
        <Form onSubmit={handleLogin} ref={form} style={{ color: "#000000" }}>
          <div
            style={{
              width: "100%",
              height: "100px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <h2 style={{ fontSize: "47px", color: "#0077B6" }}>
              แก้ไขข้อมูลผู้ใช้งาน
            </h2>
          </div>

          <h2
            style={{
              color: "#0077B6",
              height: "58px",
              fontSize: "39px",
              margin: "10px 0px 0px 40px",
            }}
          >
            ข้อมูลส่วนตัว
          </h2>
          {isCorporation !== undefined ? (
            <>
              <Row
                className="mb-3"
                style={{
                  width: "100%",
                  fontSize: "28px",
                  margin: "30px auto ",
                }}
              >
                <Form.Group as={Col} md="4">
                  <Form.Label className="font-cen">
                    เลขทะเบียนนิติบุคคล
                  </Form.Label>
                  <Form.Control
                    disabled
                    required
                    type="text"
                    className="form-input"
                    value={dataCorporation.legalentity_number}
                    onChange={(e) => {
                      setDatacorporation({
                        legalentity_number: e.target.value,
                      });
                      console.log(e.target.value);
                    }}
                  />
                  <Form.Control.Feedback>!</Form.Control.Feedback>
                </Form.Group>

                <Form.Group as={Col} md="4">
                  <Form.Label className="font-cen">
                    รหัสสาขา (ภพ. 20)
                  </Form.Label>
                  <Form.Control
                    disabled
                    required
                    type="text"
                    //placeholder={data.f_name}
                    value={dataCorporation.branch_code}
                    onChange={(e) => {
                      setDatacorporation({ branch_code: e.target.value });
                      console.log(e.target.value);
                    }}
                    className="form-input"
                  />
                  <Form.Control.Feedback>!</Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} md="4">
                  <Form.Label className="font-cen">อีเมล</Form.Label>
                  <Form.Control
                    disabled
                    required
                    type="text"
                    //placeholder={data.l_name}
                    value={dataCorporation.email}
                    onChange={(e) => {
                      setDatacorporation({ email: e.target.value });
                    }}
                    className="form-input"
                  />
                  <Form.Control.Feedback>!</Form.Control.Feedback>
                </Form.Group>
              </Row>
              <h2
                style={{
                  color: "#0077B6",
                  height: "58px",
                  fontSize: "39px",
                  margin: "60px 0px 0px 40px",
                }}
              >
                ที่อยู่ปัจจุบัน
              </h2>
              <Row
                className="mb-3"
                style={{
                  width: "100%",
                  fontSize: "28px",
                  margin: "30px auto ",
                }}
              >
                <Form.Group as={Col} md="4">
                  <Form.Label className="font-cen">
                    ที่อยู่(เลขที่, หมู่ที่, อาคาร, หมู่บ้าน, ซอย, ถนน)
                  </Form.Label>
                  <Form.Control
                    required
                    type="text"
                    //placeholder="9/40 หมู่1 หมู่บ้านกรุงไทย "
                    value={cur_address}
                    onChange={(e) => {
                      setCurAddress(e.target.value);
                    }}
                    className="form-input"
                  />
                </Form.Group>

                <Form.Group as={Col} md="4">
                  <Form.Label className="font-cen">จังหวัด</Form.Label>
                  <>
                    <Form.Control
                      type="search"
                      list="list"
                      autoComplete="on"
                      value={
                        dataCorporation.cur_province
                          ? dataCorporation.cur_province
                          : ""
                      }
                      onChange={(e) => {
                        handleChangecurprovince(e);
                      }}
                      className="form-input"
                    />
                    <datalist id="list" name="list1">
                      {showdatasearch.map((option, index) => {
                        const valueArray = [
                          option.province,
                          option.amphoe,
                          option.district,
                          option.zipcode,
                        ];

                        return (
                          <option key={index} value={valueArray}>
                            ตำบล {option.district}-{">"}
                            อำเภอ {option.amphoe}-{">"}
                            จังหวัด {option.province}-{">"}
                            รหัสไปรษณีย์ {option.zipcode}
                          </option>
                        );
                      })}
                    </datalist>
                  </>
                </Form.Group>
                <Form.Group as={Col} md="4">
                  <Form.Label className="font-cen">ตำบล</Form.Label>
                  <>
                    <Form.Control
                      type="search"
                      list="list2"
                      autoComplete="on"
                      value={
                        dataCorporation.cur_sub_dis
                          ? dataCorporation.cur_sub_dis
                          : ""
                      }
                      onChange={(e) => {
                        handleChangecurdistricts(e);
                      }}
                      className="form-input"
                    />
                    <datalist id="list2" name="list2">
                      {showdatasearch.map((option, index) => {
                        const valueArray = [
                          option.district,
                          option.amphoe,
                          option.province,
                          option.zipcode,
                        ];

                        return (
                          <option key={index} value={valueArray}>
                            ตำบล {option.district}-{">"}
                            อำเภอ {option.amphoe}-{">"}
                            จังหวัด {option.province}-{">"}
                            รหัสไปรษณีย์ {option.zipcode}
                          </option>
                        );
                      })}
                    </datalist>
                  </>
                </Form.Group>
                <Form.Group as={Col} md="4">
                  <Form.Label className="font-cen">อำเภอ</Form.Label>
                  <>
                    <Form.Control
                      type="search"
                      list="list3"
                      autoComplete="on"
                      value={
                        dataCorporation.cur_dis ? dataCorporation.cur_dis : ""
                      }
                      onChange={(e) => {
                        handleChangecuramphoe(e);
                      }}
                      className="form-input"
                    />
                    <datalist id="list3" name="list3">
                      {showdatasearch.map((option, index) => {
                        const valueArray = [
                          option.amphoe,
                          option.district,
                          option.province,
                          option.zipcode,
                        ];

                        return (
                          <option key={index} value={valueArray}>
                            ตำบล {option.district}-{">"}
                            อำเภอ {option.amphoe}-{">"}
                            จังหวัด {option.province}-{">"}
                            รหัสไปรษณีย์ {option.zipcode}
                          </option>
                        );
                      })}
                    </datalist>
                  </>
                </Form.Group>
                <Form.Group as={Col} md="4">
                  <Form.Label className="font-cen">รหัสไปรษณีย์</Form.Label>
                  <>
                    <Form.Control
                      type="search"
                      list="list4"
                      autoComplete="on"
                      value={
                        dataCorporation.cur_poscode
                          ? dataCorporation.cur_poscode
                          : ""
                      }
                      onChange={(e) => {
                        handleChangecurposcode(e);
                      }}
                      className="form-input"
                    />
                    <datalist id="list4" name="list4">
                      {showdatasearch.map((option, index) => {
                        const valueArray = [
                          option.zipcode,
                          option.district,
                          option.amphoe,
                          option.province,
                        ];

                        return (
                          <option key={index} value={valueArray}>
                            ตำบล {option.district}-{">"}
                            อำเภอ {option.amphoe}-{">"}
                            จังหวัด {option.province}-{">"}
                            รหัสไปรษณีย์ {option.zipcode}
                          </option>
                        );
                      })}
                    </datalist>
                  </>
                </Form.Group>
                <Form.Group as={Col} md="4">
                  <Form.Label className="font-cen">เบอร์โทรศัพท์</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    //placeholder={data.l_name}
                    value={phone ? phone : ""}
                    onChange={(e) => {
                      setPhone(e.target.value);
                    }}
                    className="form-input"
                  />
                  <Form.Control.Feedback>!</Form.Control.Feedback>
                </Form.Group>
              </Row>
              <div style={{ height: "50px" }} />
              <div
                style={{
                  width: "100%",
                  height: "100px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <button
                  onClick={() => Navigate(-1)}
                  ref={checkBtn}
                  className="custom-btn btnCancel"
                  style={{
                    margin: "0px 30px",
                    width: "250px",
                    height: "80px",
                    fontSize: "32px",
                  }}
                >
                  ยกเลิก
                </button>

                <button
                  type="submit"
                  className="custom-btn btnSave"
                  ref={checkBtn}
                  style={{
                    margin: "0px 30px",
                    width: "250px",
                    height: "80px",
                    fontSize: "32px",
                  }}
                >
                  บันทึก
                </button>
              </div>
            </>
          ) : (
            <>
              <Row
                className="mb-3"
                style={{
                  width: "100%",
                  fontSize: "28px",
                  margin: "30px auto ",
                }}
              >
                <Form.Group as={Col} md="4">
                  <Form.Label className="font-cen">คำนำหน้าชื่อ</Form.Label>

                  <Form.Control
                    as="select"
                    className="form-input"
                    value={data.title}
                    onChange={handleChange}
                  >
                    <option value="0">Select an option</option>
                    <option value="นาย">นาย</option>
                    <option value="นาง">นาง</option>
                    <option value="นางสาว">นางสาว</option>
                  </Form.Control>
                  <Form.Control.Feedback>!</Form.Control.Feedback>
                </Form.Group>

                <Form.Group as={Col} md="4">
                  <Form.Label className="font-cen">ชื่อ</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    className="form-input"
                    value={firstname}
                    onChange={(e) => {
                      setFirstname(e.target.value);
                      console.log(e.target.value);
                    }}
                  />
                  <Form.Control.Feedback>!</Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} md="4">
                  <Form.Label className="font-cen">นามสกุล</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    placeholder={data.l_name}
                    value={lastname}
                    onChange={(e) => {
                      setLastname(e.target.value);
                    }}
                    className="form-input"
                  />
                  <Form.Control.Feedback>!</Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} md="12">
                  <Form.Label className="font-cen">เลขบัตรประชาชน</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    maxLength={13}
                    value={data.idnum}
                    disabled
                    className="form-input"
                  />
                  <Form.Control.Feedback>!</Form.Control.Feedback>
                </Form.Group>

                <Form.Group as={Col} md="4">
                  <Form.Label className="font-cen">อีเมล</Form.Label>
                  <Form.Control
                    required
                    type="email"
                    //placeholder="name@example.com"
                    value={data.email}
                    disabled
                    className="form-input"
                  />
                  <Form.Control.Feedback>!</Form.Control.Feedback>
                </Form.Group>

                <Form.Group as={Col} md="4">
                  <Form.Label className="font-cen">เบอร์โทรศัพท์</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    aria-label="Amount (to the nearest dollar)"
                    value={phone}
                    maxLength={10}
                    onChange={(e) => {
                      setPhone(e.target.value);
                    }}
                    disabled
                    className="form-input"
                  />
                </Form.Group>
                <Form.Group as={Col} md="4">
                  <Form.Label className="font-cen">อาชีพ</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    value={occupation}
                    onChange={(e) => {
                      setOccupation(e.target.value);
                    }}
                    className="form-input"
                  />
                </Form.Group>
                <Form.Group as={Col} md="3">
                  <Form.Label className="font-cen">
                    วัน/เดือน/ปี เกิด (คศ.)
                  </Form.Label>
                  <Form.Control
                    required
                    type="date"
                    value={date_of_birth}
                    onChange={(e) => {
                      const selectedDate = new Date(e.target.value);
                      const currentDate = new Date();
                      // Check if the selected date is in the future
                      if (selectedDate > currentDate) {
                        // If it's in the future, set it to the current date
                        setDate_of_birth(
                          currentDate.toISOString().slice(0, 10)
                        );
                        // Calculate age based on the current date
                        setAge(0); // Age is set to 0 or some other appropriate value
                      } else {
                        setDate_of_birth(e.target.value);
                        if (
                          currentDate.getFullYear() -
                            selectedDate.getFullYear() >
                          99
                        ) {
                          setAge(0);
                        } else {
                          setAge(
                            currentDate.getFullYear() -
                              selectedDate.getFullYear()
                          );
                        }

                        // If it's a valid date, update the state and calculate age
                      }
                    }}
                    className="form-input"
                  />
                </Form.Group>
                <Form.Group as={Col} md="3">
                  <Form.Label className="font-cen">อายุ</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    min="0"
                    maxLength={3}
                    value={age}
                    className="form-input"
                    onChange={(e) => {
                      //setAge(date.getFullYear()-date_of_birth.substring(0,4));
                      //setAge(e.target.value);
                    }}
                    disabled
                  />
                </Form.Group>
                <Form.Group as={Col} md="3">
                  <Form.Label className="font-cen">เชื้อชาติ</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    value={race}
                    onChange={(e) => {
                      setrace(e.target.value);
                    }}
                    className="form-input"
                  />
                </Form.Group>
                <Form.Group as={Col} md="3">
                  <Form.Label className="font-cen">สัญชาติ</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    value={nationality}
                    onChange={(e) => {
                      setnationality(e.target.value);
                    }}
                    className="form-input"
                  />
                </Form.Group>
              </Row>
              <h2
                style={{
                  color: "#0077B6",
                  height: "58px",
                  fontSize: "39px",
                  margin: "60px 0px 0px 40px",
                }}
              >
                ที่อยู่ตามบัตรประชาชนหรือทะเบียนบ้าน
              </h2>
              <Row
                className="mb-3"
                style={{
                  width: "100%",
                  fontSize: "28px",
                  margin: "30px auto ",
                }}
              >
                <Form.Group as={Col} md="6">
                  <Form.Label className="font-cen">
                    ที่อยู่(เลขที่, หมู่ที่, อาคาร, หมู่บ้าน, ซอย, ถนน)
                  </Form.Label>
                  <Form.Control
                    required
                    type="text"
                    //placeholder="9/40 หมู่1 หมู่บ้านกรุงไทย "
                    value={address}
                    onChange={(e) => {
                      setAddress(e.target.value);
                    }}
                    className="form-input"
                  />
                </Form.Group>

                <Form.Group as={Col} md="6">
                  <Form.Label className="font-cen">จังหวัด</Form.Label>
                  <>
                    <Form.Control
                      type="search"
                      list="list"
                      autoComplete="on"
                      value={province ? province : ""}
                      onChange={(e) => {
                        handleChangeprovince(e);
                      }}
                      className="form-input"
                    />
                    <datalist id="list" name="list1">
                      {showdatasearch.map((option, index) => {
                        const valueArray = [
                          option.province,
                          option.amphoe,
                          option.district,
                          option.zipcode,
                        ];

                        return (
                          <option key={index} value={valueArray}>
                            ตำบล {option.district}-{">"}
                            อำเภอ {option.amphoe}-{">"}
                            จังหวัด {option.province}-{">"}
                            รหัสไปรษณีย์ {option.zipcode}
                          </option>
                        );
                      })}
                    </datalist>
                  </>
                </Form.Group>
                <Form.Group as={Col} md="4">
                  <Form.Label className="font-cen">ตำบล</Form.Label>
                  <>
                    <Form.Control
                      type="search"
                      list="list2"
                      autoComplete="on"
                      value={sub_dis ? sub_dis : ""}
                      onChange={(e) => {
                        handleChangedistricts(e);
                      }}
                      className="form-input"
                    />
                    <datalist id="list2" name="list2">
                      {showdatasearch.map((option, index) => {
                        const valueArray = [
                          option.district,
                          option.amphoe,
                          option.province,
                          option.zipcode,
                        ];

                        return (
                          <option key={index} value={valueArray}>
                            ตำบล {option.district}-{">"}
                            อำเภอ {option.amphoe}-{">"}
                            จังหวัด {option.province}-{">"}
                            รหัสไปรษณีย์ {option.zipcode}
                          </option>
                        );
                      })}
                    </datalist>
                  </>
                </Form.Group>
                <Form.Group as={Col} md="4">
                  <Form.Label className="font-cen">อำเภอ</Form.Label>
                  <>
                    <Form.Control
                      type="search"
                      list="list3"
                      autoComplete="on"
                      value={dis ? dis : ""}
                      onChange={(e) => {
                        handleChangeamphoe(e);
                      }}
                      className="form-input"
                    />
                    <datalist id="list3" name="list3">
                      {showdatasearch.map((option, index) => {
                        const valueArray = [
                          option.amphoe,
                          option.district,
                          option.province,
                          option.zipcode,
                        ];

                        return (
                          <option key={index} value={valueArray}>
                            ตำบล {option.district}-{">"}
                            อำเภอ {option.amphoe}-{">"}
                            จังหวัด {option.province}-{">"}
                            รหัสไปรษณีย์ {option.zipcode}
                          </option>
                        );
                      })}
                    </datalist>
                  </>
                </Form.Group>
                <Form.Group as={Col} md="4">
                  <Form.Label className="font-cen">รหัสไปรษณีย์</Form.Label>
                  <>
                    <Form.Control
                      type="search"
                      list="list4"
                      autoComplete="on"
                      value={pos_code ? pos_code : ""}
                      onChange={(e) => {
                        handleChangeposcode(e);
                      }}
                      className="form-input"
                    />
                    <datalist id="list4" name="list4">
                      {showdatasearch.map((option, index) => {
                        const valueArray = [
                          option.zipcode,
                          option.district,
                          option.amphoe,
                          option.province,
                        ];

                        return (
                          <option key={index} value={valueArray}>
                            ตำบล {option.district}-{">"}
                            อำเภอ {option.amphoe}-{">"}
                            จังหวัด {option.province}-{">"}
                            รหัสไปรษณีย์ {option.zipcode}
                          </option>
                        );
                      })}
                    </datalist>
                  </>
                </Form.Group>
              </Row>
              <div style={{ display: "flex" }}>
                <h2
                  style={{
                    color: "#0077B6",
                    height: "58px",
                    fontSize: "39px",
                    margin: "60px 0px 0px 40px",
                  }}
                >
                  ที่อยู่ปัจจุบัน
                </h2>
                <div>
                  <Form.Group
                    className="mb-3"
                    style={{
                      color: "#0077B6",
                      margin: "60px 0px 0px 90px",
                      width: "300px",
                    }}
                  >
                    <Form.Check
                      label="ที่อยู่ปัจจุบันตามที่อยู่ทะเบียนบ้าน"
                      checked={Same}
                      onClick={() => setSame(!Same)}
                      style={{
                        fontSize: "24px",
                        width: "500px",
                        margin: "70px 0px 0px 10px",
                      }}
                    />
                  </Form.Group>
                </div>
              </div>
              {Same ? (
                ""
              ) : (
                <Row
                  className="mb-3"
                  style={{
                    width: "100%",
                    fontSize: "28px",
                    margin: "30px auto ",
                  }}
                >
                  <Form.Group as={Col} md="6">
                    <Form.Label className="font-cen">
                      ที่อยู่(เลขที่, หมู่ที่, อาคาร, หมู่บ้าน, ซอย, ถนน)
                    </Form.Label>
                    <Form.Control
                      required={!Same}
                      type="text"
                      value={cur_address}
                      onChange={(e) => {
                        setCurAddress(e.target.value);
                      }}
                      className="form-input"
                    />
                  </Form.Group>

                  <Form.Group as={Col} md="6">
                    <Form.Label className="font-cen">จังหวัด</Form.Label>
                    <>
                      <Form.Control
                        required={!Same}
                        type="search"
                        list="curlist"
                        autoComplete="on"
                        value={cur_province ? cur_province : ""}
                        onChange={(e) => {
                          handleChangecurprovince(e);
                        }}
                        className="form-input"
                      />
                      <datalist id="curlist" name="list1">
                        {showdatasearch.map((option, index) => {
                          const valueArray = [
                            option.province,
                            option.amphoe,
                            option.district,
                            option.zipcode,
                          ];

                          return (
                            <option key={index} value={valueArray}>
                              ตำบล {option.district}-{">"}
                              อำเภอ {option.amphoe}-{">"}
                              จังหวัด {option.province}-{">"}
                              รหัสไปรษณีย์ {option.zipcode}
                            </option>
                          );
                        })}
                      </datalist>
                    </>
                  </Form.Group>
                  <Form.Group as={Col} md="4">
                    <Form.Label className="font-cen">ตำบล</Form.Label>
                    <>
                      <Form.Control
                        required={!Same}
                        type="search"
                        list="curlist2"
                        autoComplete="on"
                        value={cur_sub_dis ? cur_sub_dis : ""}
                        onChange={(e) => {
                          handleChangecurdistricts(e);
                        }}
                        className="form-input"
                      />
                      <datalist id="curlist2" name="list2">
                        {showdatasearch.map((option, index) => {
                          const valueArray = [
                            option.district,
                            option.amphoe,
                            option.province,
                            option.zipcode,
                          ];

                          return (
                            <option key={index} value={valueArray}>
                              ตำบล {option.district}-{">"}
                              อำเภอ {option.amphoe}-{">"}
                              จังหวัด {option.province}-{">"}
                              รหัสไปรษณีย์ {option.zipcode}
                            </option>
                          );
                        })}
                      </datalist>
                    </>
                  </Form.Group>
                  <Form.Group as={Col} md="4">
                    <Form.Label className="font-cen">อำเภอ</Form.Label>
                    <>
                      <Form.Control
                        required={!Same}
                        type="search"
                        list="curlist3"
                        autoComplete="on"
                        value={cur_dis ? cur_dis : ""}
                        onChange={(e) => {
                          handleChangecuramphoe(e);
                        }}
                        className="form-input"
                      />
                      <datalist id="curlist3" name="list3">
                        {showdatasearch.map((option, index) => {
                          const valueArray = [
                            option.amphoe,
                            option.district,
                            option.province,
                            option.zipcode,
                          ];

                          return (
                            <option key={index} value={valueArray}>
                              ตำบล {option.district}-{">"}
                              อำเภอ {option.amphoe}-{">"}
                              จังหวัด {option.province}-{">"}
                              รหัสไปรษณีย์ {option.zipcode}
                            </option>
                          );
                        })}
                      </datalist>
                    </>
                  </Form.Group>
                  <Form.Group as={Col} md="4">
                    <Form.Label className="font-cen">รหัสไปรษณีย์</Form.Label>
                    <>
                      <Form.Control
                        required={!Same}
                        type="search"
                        list="curlist4"
                        autoComplete="on"
                        value={cur_poscode ? cur_poscode : ""}
                        onChange={(e) => {
                          handleChangecurposcode(e);
                        }}
                        className="form-input"
                      />
                      <datalist id="curlist4" name="list4">
                        {showdatasearch.map((option, index) => {
                          const valueArray = [
                            option.zipcode,
                            option.district,
                            option.amphoe,
                            option.province,
                          ];

                          return (
                            <option key={index} value={valueArray}>
                              ตำบล {option.district}-{">"}
                              อำเภอ {option.amphoe}-{">"}
                              จังหวัด {option.province}-{">"}
                              รหัสไปรษณีย์ {option.zipcode}
                            </option>
                          );
                        })}
                      </datalist>
                    </>
                  </Form.Group>
                </Row>
              )}
              <div style={{ height: "50px" }} />
              <div
                style={{
                  width: "100%",
                  height: "100px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <button
                  onClick={() => Navigate(-1)}
                  ref={checkBtn}
                  className="custom-btn btnCancel"
                  style={{
                    margin: "0px 30px",
                    width: "250px",
                    height: "80px",
                    fontSize: "32px",
                  }}
                >
                  ยกเลิก
                </button>

                <button
                  type="submit"
                  className="custom-btn btnSave"
                  ref={checkBtn}
                  style={{
                    margin: "0px 30px",
                    width: "250px",
                    height: "80px",
                    fontSize: "32px",
                  }}
                >
                  บันทึก
                </button>
              </div>
            </>
          )}

          <div style={{ height: "50px" }} />
          <Static_modal
            modalwaiting={modalToggle.modalwait}
            modalErr={modalToggle.modalErr}
            modalSuccess={modalToggle.modalSuccess}
            modalDenied={modalToggle.modalDenied}
            textBody={textBody}
            getHandle={handleClose_Modal}
          />
          <Modal
            show={checkuserdata}
            centered
            onHide={handleClose}
            //style={{ color: "red", background: "rgba(0,0,0,0.9)" }}
            className="font-cen"
          >
            <Modal.Body
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                //background: "black",
              }}
            >
              <h3>กรุณาใส่ข้อมูลส่วนตัวให้เรียบร้อย</h3>
            </Modal.Body>
          </Modal>
          <Modal
            show={modalsuccess}
            centered
            onHide={handleClose}
            //style={{ color: "red", background: "rgba(0,0,0,0.9)" }}
            className="font-cen"
          >
            <Modal.Body
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                //background: "black",
              }}
            >
              <h3>บันทึกข้อมูลเรียบร้อย</h3>
            </Modal.Body>
          </Modal>
        </Form>
      </div>
    </div>
  );
}
export default EditProfileUser;
